@use "../../../../../styles/Constants.scss" as Constants;
@use "../../../../../styles/Colors.scss" as Colors;

.deleteAndUndoCell {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex: 1;

	.icon {
		padding: Constants.$val-spacing-xs;
		color: Colors.$col-design-blue500;
		cursor: pointer;
		font-size: Constants.$val-icon16;

		&.delete {
			color: Colors.$col-design-red600;
		}
	}
}
